import React, { useEffect } from 'react';
import { PageLayout } from '@/shared/layout';
import { Button, Card, Input, TextArea } from '@/components/ui';
import { useAuth } from '@/core/auth/AuthContext';
import { useCompany } from './hooks/useCompany';
import { useForm } from 'react-hook-form';
import { toast } from 'sonner';

export default function CompanySettingsPage() {
  const { profile } = useAuth();
  const companyId = profile?.company_id;
  const { company, isLoading, updateCompany, isUpdating: isPending } = useCompany(companyId);

  const { register, handleSubmit, reset } = useForm({
    defaultValues: {
      name: '',
      description: '',
      website: '',
      email: '',
      phone: '',
      address: '',
      city: '',
      country: '',
    }
  });

  useEffect(() => {
    if (company) {
      reset({
        name: company.name,
        description: company.description || '',
        website: company.website || '',
        email: company.email || '',
        phone: company.phone || '',
        address: company.address || '',
        city: company.city || '',
        country: company.country || '',
      });
    }
  }, [company, reset]);

  const onSubmit = (data: any) => {
    if (!companyId) return;
    updateCompany(data);
  };

  return (
    <PageLayout
      title="Thiết lập Công ty"
      description="Quản lý thông tin cơ bản, nhận diện và thông tin liên hệ của tổ chức."
      breadcrumbs={[
        { label: 'Công ty', path: '/company' },
        { label: 'Thiết lập' }
      ]}
      isLoading={isLoading}
    >
      <div className="max-w-4xl space-y-6">
        <Card className="p-6">
          <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="md:col-span-2">
                <Input
                  label="Tên công ty"
                  placeholder="Ví dụ: Landscape Solutions"
                  {...register('name', { required: true })}
                />
              </div>
              <div className="md:col-span-2">
                <TextArea
                  label="Mô tả"
                  placeholder="Mô tả ngắn gọn về công ty của bạn..."
                  rows={3}
                  {...register('description')}
                />
              </div>
              <Input
                label="Website"
                placeholder="https://example.com"
                {...register('website')}
              />
              <Input
                label="Email liên hệ"
                type="email"
                placeholder="contact@company.com"
                {...register('email')}
              />
              <Input
                label="Số điện thoại"
                placeholder="028 1234 5678"
                {...register('phone')}
              />
              <Input
                label="Địa chỉ"
                placeholder="Số 1, Đường 1, Phường 1..."
                {...register('address')}
              />
              <Input
                label="Thành phố"
                placeholder="Hồ Chí Minh"
                {...register('city')}
              />
              <Input
                label="Quốc gia"
                placeholder="Việt Nam"
                {...register('country')}
              />
            </div>

            <div className="flex justify-end pt-4 border-t border-slate-100">
              <Button type="submit" isLoading={isPending}>
                Lưu thay đổi
              </Button>
            </div>
          </form>
        </Card>

        {/* Danger Zone */}
        <Card className="p-6 border-red-100 bg-red-50/30">
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
            <div>
              <h4 className="text-lg font-semibold text-red-700">Vùng nguy hiểm</h4>
              <p className="text-sm text-red-600">Xóa dữ liệu công ty hoặc hủy kích hoạt tài khoản tổ chức.</p>
            </div>
            <Button variant="danger" outline>
              Hủy kích hoạt tổ chức
            </Button>
          </div>
        </Card>
      </div>
    </PageLayout>
  );
}
